import { gql } from "@apollo/client";

const BANK_QUESTION_FIELDS = gql`
  fragment BankQuestionFields on BankQuestion {
    id
    text
    scoringGuide {
      level1
      level2
      level3
      level4
      level5
    }
    kssartiTopic
    division
    jobTitle
    addedBy {
      id
      firstName
      lastName
    }
    updatedBy {
      id
      firstName
      lastName
    }
    createdAt
    updatedAt
  }
`;

export const GET_QUESTION_BANK = gql`
  ${BANK_QUESTION_FIELDS}
  query GetQuestionBank($filter: QuestionBankFilter, $pagination: Pagination) {
    questionBank(filter: $filter, pagination: $pagination) {
      items {
        ...BankQuestionFields
      }
      pageInfo {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
`;

export const CREATE_BANK_QUESTION = gql`
  ${BANK_QUESTION_FIELDS}
  mutation CreateBankQuestion($input: BankQuestionCreateInput!) {
    bankQuestionCreate(input: $input) {
      bankQuestion {
        ...BankQuestionFields
      }
      errors {
        message
        code
      }
    }
  }
`;

export const UPDATE_BANK_QUESTION = gql`
  ${BANK_QUESTION_FIELDS}
  mutation UpdateBankQuestion($id: ID!, $input: BankQuestionUpdateInput!) {
    bankQuestionUpdate(id: $id, input: $input) {
      bankQuestion {
        ...BankQuestionFields
      }
      errors {
        message
        code
      }
    }
  }
`;

export const DELETE_BANK_QUESTION = gql`
  mutation DeleteBankQuestion($id: ID!) {
    bankQuestionDelete(id: $id) {
      bankQuestion {
        id
      }
      errors {
        message
        code
      }
    }
  }
`;
